/* global angular */

var ngModule = angular.module('trends');

ngModule.directive('accessCheck', ['Redirect',
    function (Redirect) {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
                Redirect.initialize(
                    {isLoggedIn: attrs.loggedIn === 'True', hasTrendsAccess: attrs.trendsAccess === 'True'}
                );
            }
        };
    }]);
